import { BaseEntity, BaseSearchForm } from 'entities'
import { HasAddress } from './address'

export type Vendor = BaseEntity &
    HasAddress & {
        code?: string
        name?: string
        tel?: string
        contractDate?: string
        addressId?: number
        type?: string
    }

export type VendorForm = Vendor

export type VendorSearchForm = BaseSearchForm & {
    name?: string
    id?: string
}

export const VENDOR_TYPE = ['SALES', 'SHIPPING']
export const VENDOR_TYPE_JA = ['営業', '運送']
export const VENDOR_TYPE_SELECT_ITEMS = VENDOR_TYPE.map((v, i) => {
    return { label: VENDOR_TYPE_JA[i], value: v }
})
